export default __webpack_public_path__ + "static/media/uploader-abbottLite-1.a8125d94.png";